import Model from "../Model";

export default class extends Model {
    async loadTable(
      page,
      per_page,
      search = '',
      brand_id = null,
      client_id = null,
      device_type_id = null,
      device_operating_system_id = null,
      device_software_version_id = null,
      build_date = null,
      currentSortColumn = null,
      currentSortOrder = null
    ) {
        let lastPage = 1;
        let response = await axios.get(this.urls.list, {
            params: {
                page,
                per_page,
                search,
                brand_id,
                client_id,
                device_type_id,
                device_operating_system_id,
                device_software_version_id,
                build_date,
                currentSortColumn,
                currentSortOrder
            }
        }).then(response => {

            lastPage = response.data.meta.last_page;

            if(response.data.data !== undefined)
            {
                if(response.data.data.length > 0)
                {
                    return response.data;
                }
            }
            return false;
        });

        let result = {
            tbody: [],
            pages: lastPage,
        };

        if(response.data !== undefined && response.data.length > 0)
        {
            response.data.forEach(deviceImage => {
                let telem = {
                    tbody: {}
                };
                telem.id = deviceImage.id;
                telem.is_active = deviceImage.is_active;
                telem.tbody.name = deviceImage.name;
                telem.tbody.version = deviceImage.version;
                telem.tbody.description = deviceImage.description;
                telem.tbody.build_date = deviceImage.build_date;
                telem.tbody.device_type = deviceImage.device_software_version.device_type.name;
                telem.tbody.os = deviceImage.device_software_version.device_operating_system.name;
                telem.tbody.device_software_version = deviceImage.device_software_version.full_version;
                telem.tbody.brand = deviceImage.device_software_version.brand.name;
                telem.tbody.client = deviceImage.device_software_version.client.name;
                telem.tbody.file_size = deviceImage.file_size;
                telem.tbody.file_path = deviceImage.file_path;
                telem.tbody.updated_at = deviceImage.updated_at;
                telem.tbody.compatible_devices_count = deviceImage.compatible_devices_count;
                result.tbody.push(telem);
            });
        }
        return result;
    }
}
